import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <div className="container">
        <div className="not-found-content">
          <div className="error-code">404</div>
          <h1>Trang không tìm thấy</h1>
          <p>Xin lỗi, trang bạn đang tìm kiếm không tồn tại hoặc đã được di chuyển.</p>
          
          <div className="suggestions">
            <h3>Bạn có thể:</h3>
            <ul>
              <li>Kiểm tra lại đường dẫn URL</li>
              <li>Quay về trang chủ</li>
              <li>Tìm kiếm thông tin bạn cần</li>
              <li>Liên hệ với chúng tôi để được hỗ trợ</li>
            </ul>
          </div>
          
          <div className="action-buttons">
            <Link to="/" className="btn btn-primary">Về trang chủ</Link>
            <Link to="/contact" className="btn btn-secondary">Liên hệ hỗ trợ</Link>
          </div>
          
          <div className="quick-links">
            <h3>Liên kết hữu ích</h3>
            <div className="links-grid">
              <Link to="/services" className="quick-link">
                <span className="link-icon">🛠️</span>
                <span>Dịch vụ</span>
              </Link>
              <Link to="/projects" className="quick-link">
                <span className="link-icon">🏗️</span>
                <span>Dự án</span>
              </Link>
              <Link to="/about" className="quick-link">
                <span className="link-icon">🏢</span>
                <span>Giới thiệu</span>
              </Link>
              <Link to="/careers" className="quick-link">
                <span className="link-icon">💼</span>
                <span>Tuyển dụng</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;